<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/repertoryList' }">库存</el-breadcrumb-item>
                <el-breadcrumb-item>库存{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <!-- 下拉 -->
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params'] || {}"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                        :is_disable="type == 'update' && item['prop'] == 'parent_rid'"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <!-- 下拉搜索 -->
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <!-- 日期 -->
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <!-- 输入框 -->
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        :disabled="type == 'update' && item['prop'] == 'code'"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <!-- 只读文本 -->
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, checkNumber, processColDataToEdit } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'repertoryEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                principal_rid: {
                    request_uri: 'dropdownPerson',
                    title: '负责人',
                    ref: 'principal_rid_ref',
                    display_name: 'name',
                    type: 'dropdown'
                },
                date: {
                    title: '库存日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'date_ref',
                    type: 'date'
                },
                closed_date: {
                    title: '关闭日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'closed_date_ref',
                    type: 'date'
                },
                business_rid: {
                    request_uri: 'searchAccounts',
                    title: '一级商业',
                    ref: 'business_rid_ref',
                    default_option_key: 'business_option',
                    type: 'search_select'
                },
                partner_rid: {
                    request_uri: 'dropdownPartners',
                    title: '合作方',
                    ref: 'partner_rid_ref',
                    type: 'dropdown'
                },
                partner_status: {
                    request_uri: 'dropdownPartnerStatus',
                    title: '合作状态',
                    ref: 'partner_status_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                confidence: {
                    request_uri: 'confidenceSimple',
                    title: '确信度',
                    ref: 'confidence_ref',
                    display_name: 'name',
                    select_value: 'value',
                    type: 'dropdown'
                },
                product_owner_rid: {
                    request_uri: 'searchAccounts',
                    title: '产品所有者',
                    ref: 'product_owner_rid_ref',
                    default_option_key: 'product_owner_option',
                    type: 'search_select'
                },
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    request_params: { is_all: true, type_code: [11, 91] }
                }
            };
        },
        initFormRule() {
            this.rules = {
                principal_rid: [{ required: true, message: '请选择负责人', trigger: 'blur' }],
                date: [{ required: true, message: '请输入库存日期', trigger: 'blur' }],
                closed_date: [{ required: false, message: '请输入关闭日期', trigger: 'blur' }],
                business_rid: [{ required: true, message: '请输入一级商业搜索', trigger: 'blur' }],
                partner_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                partner_status: [{ required: true, message: '请选择合作状态', trigger: 'blur' }],
                confidence: [{ required: false, message: '请选择确信度', trigger: 'blur' }],
                quantity_balance: { required: true, validator: checkNumber, trigger: 'blur' },
                in_transit_quantity: { required: true, validator: checkNumber, trigger: 'blur' },
                adjustment_quantity: { required: false, validator: checkNumber, trigger: 'blur' },
                product_owner_rid: [{ required: true, message: '请输入产品所有者搜索搜索', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                product_batch_number: [{ required: false, message: '请输入批号', trigger: 'blur' }],
                comment: [{ required: false, message: '请输入备注', trigger: 'blur' }],
                total_price_tax_excluded: { required: true, validator: checkNumber, trigger: 'blur' },
                total_price_tax_included: { required: true, validator: checkNumber, trigger: 'blur' }
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                principal_rid: this.data.principal_rid || '',
                date: this.data.date || '',
                business_rid: this.data.business_rid || '',
                partner_rid: this.data.partner_rid || '',
                quantity_balance: this.data.quantity_balance || '0',
                in_transit_quantity: this.data.in_transit_quantity || '0',
                adjustment_quantity: this.data.adjustment_quantity || '0',
                partner_status: this.data.partner_status || '',
                confidence: this.data.confidence || '',
                closed_date: this.data.closed_date || '',
                product_owner_rid: this.data.product_owner_rid || '',
                product_rid: this.data.product_rid || '',
                product_batch_number: this.data.product_batch_number || '',
                comment: this.data.comment || '',
                total_price_tax_excluded: this.data.total_price_tax_excluded || '0',
                total_price_tax_included: this.data.total_price_tax_included || '0',
                business_option: {
                    rid: this.data.business_rid || '',
                    name: this.data.business ? this.data.business : ''
                },
                product_owner_option: {
                    rid: this.data.product_owner_rid || '',
                    name: this.data.owner ? this.data.owner : ''
                }
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).commodity_stock;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'date',
                        'quantity_balance',
                        'closed_date',
                        'in_transit_quantity',
                        'adjustment_quantity',
                        'product_batch_number',
                        'comment',
                        'total_price_tax_excluded',
                        'total_price_tax_included'
                    ]
                },
                {
                    principal: 'principal_rid',
                    business: 'business_rid',
                    partner: 'partner_rid',
                    partner_status_label: 'partner_status',
                    confidence_label: 'confidence',
                    owner: 'product_owner_rid',
                    product: 'product_rid'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/repertoryList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .stockSourceDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'stockSourceUpdate';
            } else {
                uri = 'stockSourceInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                    }
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>